import { render, staticRenderFns } from "./LongTextFormItem.vue?vue&type=template&id=4d3c615a&scoped=true"
import script from "./LongTextFormItem.vue?vue&type=script&lang=js"
export * from "./LongTextFormItem.vue?vue&type=script&lang=js"
import style0 from "./LongTextFormItem.vue?vue&type=style&index=0&id=4d3c615a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c615a",
  null
  
)

export default component.exports